var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductDescriptionGeneratorLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#DF1E5B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33157_317809)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    transform: "translate(7.19922 7.19922)",
    fill: "#DF1E5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9082 14.9361C9.9082 14.4391 10.3075 14.0361 10.8 14.0361H30.6164C31.1089 14.0361 31.5082 14.4391 31.5082 14.9361C31.5082 15.4332 31.1089 15.8361 30.6164 15.8361H10.8C10.3075 15.8361 9.9082 15.4332 9.9082 14.9361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9082 10.1803C9.9082 9.68322 10.3205 9.28027 10.829 9.28027H35.3827C35.8913 9.28027 36.3035 9.68322 36.3035 10.1803C36.3035 10.6773 35.8913 11.0803 35.3827 11.0803H10.829C10.3205 11.0803 9.9082 10.6773 9.9082 10.1803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9082 19.691C9.9082 19.194 10.2885 18.791 10.7577 18.791H25.8587C26.3279 18.791 26.7082 19.194 26.7082 19.691C26.7082 20.1881 26.3279 20.591 25.8587 20.591H10.7577C10.2885 20.591 9.9082 20.1881 9.9082 19.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4885 17.6199C33.9359 17.8455 34.1785 18.3413 34.0821 18.8331L32.9344 24.6889L37.3705 26.3864C37.7161 26.5186 37.9738 26.8132 38.059 27.1732C38.1441 27.5333 38.0456 27.9121 37.7959 28.1851L28.4953 38.3534C28.1571 38.7232 27.6142 38.8227 27.1669 38.597C26.7195 38.3713 26.4769 37.8755 26.5733 37.3838L27.721 31.528L23.2849 29.8305C22.9393 29.6983 22.6816 29.4037 22.5964 29.0436C22.5113 28.6836 22.6098 28.3048 22.8595 28.0318L32.1601 17.8635C32.4983 17.4937 33.0412 17.3942 33.4885 17.6199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33157_317809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    fill: "white",
    transform: "translate(7.19922 7.19922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionGeneratorLoader);
export default __webpack_public_path__ + "static/media/product-description-generator-loader.6bbbf11cf0d272b98919b55d755330a1.svg";
export { ForwardRef as ReactComponent };